export const SERVICES = [
  {
    id: "sba",
    number: "01",
    title: "SBA Loans",
    subtitle: "Government-backed. Long-term.",
    description:
      "Access up to $5M in SBA-guaranteed capital with the lowest rates and longest terms in the market. Built for expansion, real estate, and refinancing.",
    highlights: ["Up to $5,000,000", "10–25 year terms", "As low as Prime + 2.75%"],
    image:
      "https://images.unsplash.com/photo-1758866555610-c44c609ae88b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBicnV0YWxpc3QlMjBhcmNoaXRlY3R1cmUlMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODQ1MDcwODN8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "bloc",
    number: "02",
    title: "Business Line of Credit",
    subtitle: "Draw only what you need.",
    description:
      "A revolving credit facility that flexes with your operations. Pay interest only on the balance you use — perfect for payroll gaps, inventory, and opportunity.",
    highlights: ["Up to $500,000", "Revolving access", "Interest on used balance only"],
    image:
      "https://images.pexels.com/photos/33866469/pexels-photo-33866469.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "revenue",
    number: "03",
    title: "Revenue Based Financing",
    subtitle: "Same-day. Repayment tied to sales.",
    description:
      "Non-dilutive capital repaid as a percentage of future revenue — often funded the same day. No fixed monthly payments: you pay more when business is strong, less when it's slow.",
    highlights: ["$25K – $2M", "Same-day funding available", "No equity dilution"],
    image:
      "https://images.pexels.com/photos/33866469/pexels-photo-33866469.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "equipment",
    number: "04",
    title: "Equipment Financing",
    subtitle: "Own it. Deduct it.",
    description:
      "Finance the machinery, vehicles, and hardware that build your business. Fixed monthly payments with Section 179 tax advantages baked in.",
    highlights: ["100% financing", "3–7 year terms", "Section 179 eligible"],
    image:
      "https://images.unsplash.com/photo-1496247749665-49cf5b1022e9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxoZWF2eSUyMGluZHVzdHJpYWwlMjBtYWNoaW5lcnklMjBmYWN0b3J5fGVufDB8fHx8MTc4NDUwNzA4M3ww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "working-capital",
    number: "05",
    title: "Working Capital",
    subtitle: "Short-term fuel.",
    description:
      "Lump-sum capital in as little as 24 hours to bridge cash flow, cover payroll, or seize a time-sensitive opportunity. Simple daily or weekly repayments.",
    highlights: ["$10K – $1M", "Funded in 24–48 hrs", "6–24 month terms"],
    image:
      "https://images.unsplash.com/photo-1758866555610-c44c609ae88b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBicnV0YWxpc3QlMjBhcmNoaXRlY3R1cmUlMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODQ1MDcwODN8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "mca",
    number: "06",
    title: "Merchant Cash Advance",
    subtitle: "Sell against future sales.",
    description:
      "Advance on your future card sales — repaid as a percentage of daily receipts. Approvals possible even with challenged credit or thin file.",
    highlights: ["$5K – $500K", "Approval in hours", "Bad credit considered"],
    image:
      "https://images.pexels.com/photos/12471781/pexels-photo-12471781.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "term-loans",
    number: "07",
    title: "Term Loans",
    subtitle: "Lump sum. Fixed schedule.",
    description:
      "Traditional business term loans from banks and fintech lenders — one lump sum, fixed monthly payment, predictable payoff. For growth, expansion, and projects with a clear ROI window.",
    highlights: ["$25K – $2M", "1–5 year terms", "Bank & fintech pricing"],
    image:
      "https://images.unsplash.com/photo-1758866555610-c44c609ae88b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBicnV0YWxpc3QlMjBhcmNoaXRlY3R1cmUlMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODQ1MDcwODN8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "bridge",
    number: "08",
    title: "Bridge Loans",
    subtitle: "Between two doors.",
    description:
      "Short-term capital that bridges a specific gap — an SBA loan closing 45 days out, an acquisition awaiting refinance, a payroll gap before a big receivable clears. Repaid from a known future event.",
    highlights: ["$50K – $5M", "3–24 month terms", "Interest-only options"],
    image:
      "https://images.pexels.com/photos/33866469/pexels-photo-33866469.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "startup",
    number: "09",
    title: "Startup Financing",
    subtitle: "For businesses under two years.",
    description:
      "Funding options built for the first 24 months of business: personal-credit-backed lines of credit, SBA microloans, and equipment financing that doesn't require two years of tax returns yet.",
    highlights: ["Under 2 yrs OK", "Personal-credit driven", "$10K – $250K"],
    image:
      "https://images.pexels.com/photos/12471781/pexels-photo-12471781.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "fix-and-flip",
    number: "10",
    title: "Fix and Flip Financing",
    subtitle: "Buy, renovate, sell.",
    description:
      "Short-term real estate loans for investors flipping residential properties. Covers purchase price plus rehab budget, 6–18 month terms, funded fast so you don't miss the deal.",
    highlights: ["Up to 90% purchase + 100% rehab", "6–18 month terms", "Funded in 10–14 days"],
    image:
      "https://images.unsplash.com/photo-1496247749665-49cf5b1022e9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxoZWF2eSUyMGluZHVzdHJpYWwlMjBtYWNoaW5lcnklMjBmYWN0b3J5fGVufDB8fHx8MTc4NDUwNzA4M3ww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "purchase-order",
    number: "11",
    title: "Purchase Order Financing",
    subtitle: "Fund the order, ship the goods.",
    description:
      "Advances against confirmed purchase orders so you can pay suppliers, fulfill large contracts, and keep the margin. Especially useful for importers, manufacturers, and wholesalers scaling into big orders.",
    highlights: ["Up to 100% of supplier cost", "Advance in 3–7 days", "Credit less-weighted"],
    image:
      "https://images.unsplash.com/photo-1496247749665-49cf5b1022e9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxoZWF2eSUyMGluZHVzdHJpYWwlMjBtYWNoaW5lcnklMjBmYWN0b3J5fGVufDB8fHx8MTc4NDUwNzA4M3ww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "accounts-receivable",
    number: "12",
    title: "Accounts Receivable Financing",
    subtitle: "Cash today from tomorrow's invoices.",
    description:
      "Factor or borrow against unpaid B2B invoices. Turns 30/60/90-day payment terms into same-week cash — at rates far below MCA territory. Ideal for staffing, trucking, and B2B services.",
    highlights: ["Up to 90% invoice advance", "Non-recourse options", "Weekly or monthly draws"],
    image:
      "https://images.pexels.com/photos/33866469/pexels-photo-33866469.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "franchise",
    number: "13",
    title: "Franchise Financing",
    subtitle: "For qualified franchisees.",
    description:
      "Tailored funding for franchise purchases, remodels, and multi-unit expansion. SBA-preferred lenders for FDD-listed franchise brands plus specialized programs for approved concepts.",
    highlights: ["SBA 7(a) up to $5M", "Equipment + build-out combined", "Approved franchise brands"],
    image:
      "https://images.pexels.com/photos/12471781/pexels-photo-12471781.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "residential-investment",
    number: "14",
    title: "Residential Investment Financing",
    subtitle: "For rental portfolios & long-term holds.",
    description:
      "DSCR loans, portfolio loans, and cash-out refinances for residential investment real estate. Underwritten on the property's rental income, not just yours — 30-year fixed options available.",
    highlights: ["DSCR from 0.75", "Portfolio loans up to 10 properties", "30-year fixed options"],
    image:
      "https://images.unsplash.com/photo-1758866555610-c44c609ae88b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBicnV0YWxpc3QlMjBhcmNoaXRlY3R1cmUlMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODQ1MDcwODN8MA&ixlib=rb-4.1.0&q=85",
  },
];

export const PROCESS_STEPS = [
  {
    num: "01",
    title: "Apply in 4 minutes",
    body:
      "A single application, no obligation, no credit pull. We collect only what's essential to shop your file across our lender network.",
  },
  {
    num: "02",
    title: "We shop your file",
    body:
      "Our brokers match your business against 75+ lenders — banks, private capital, and SBA preferred partners — to surface the best available terms.",
  },
  {
    num: "03",
    title: "Offers, side by side",
    body:
      "You review real, competing offers in plain English. We negotiate on your behalf and walk you through every line before you sign.",
  },
  {
    num: "04",
    title: "Fund and grow",
    body:
      "Once you approve, capital lands in your operating account — often the same week. We stay in the loop as your business scales.",
  },
];

// Representative examples — composite illustrations of typical broker outcomes,
// not attributed to specific real clients. Update with real quotes once collected.
export const TESTIMONIALS_DISCLAIMER =
  "Representative example — composite illustrations of typical broker outcomes.";

export const TESTIMONIALS = [
  {
    quote:
      "The offer my bank put on the table looked fine — until Steady Path pulled a second SBA quote and negotiated almost a full point off the rate. That's real money over ten years.",
    name: "Manufacturing client · IL",
    role: "SBA 7(a) · $850K · Working capital + equipment",
    initials: "MC",
    accent: "#C4A47C",
  },
  {
    quote:
      "I was declined by my local bank on a Monday. Steady Path found me a fintech line of credit and $180K landed in the operating account by Friday. No theatrics, just work.",
    name: "Grocery client · IN",
    role: "Fintech LOC · $180K · Inventory + payroll",
    initials: "GC",
    accent: "#F4F4F0",
  },
  {
    quote:
      "Refinanced two stacked advances into a single working-capital line at less than a third of the effective rate. They walked me through the math before we consolidated — no pressure, just numbers.",
    name: "Logistics client · MI",
    role: "MCA refi → Term loan · $220K · Consolidation",
    initials: "LC",
    accent: "#C4A47C",
  },
];

export const FAQS = [
  {
    q: "Are you a lender?",
    a: "No — we're a brokerage. We work on your behalf across a network of 75+ vetted lenders (banks, SBA preferred partners, and private capital) to find the strongest terms for your business.",
  },
  {
    q: "Do you have a minimum FICO score?",
    a: "No. We work with every credit profile — including thin file, prior bankruptcy, and scores under 550. Because we shop 75+ lenders (including revenue-first fintechs that underwrite off bank statements rather than credit), we can typically place a file at any credit level. Higher scores unlock better pricing, but nothing about your credit disqualifies you from applying.\n\n[See the illustrative walkthrough →](/deal-structures/bad-credit-restaurant-revenue-financing-95k)",
  },
  {
    q: "What documents do you need?",
    a: "For most products, we only need 4–6 months of business bank statements. No merchant processor statements (Square, Stripe, PayPal, Venmo, etc.), no tax returns for revenue-based products, and no personal financial deep-dive. SBA and bank term loans require additional documentation, but our fintech and revenue products approve off bank statements alone.\n\n[See the illustrative walkthrough →](/deal-structures/working-capital-franchise-310k-holiday-inventory)",
  },
  {
    q: "Will applying hurt my credit?",
    a: "Applying with us is a soft inquiry only. We do not pull a hard credit report until you've reviewed offers and formally chosen to move forward.",
  },
  {
    q: "Will these loans affect my personal credit?",
    a: "No. We are business-based loan brokers — we specialize in business loans. Typically these loans do not appear on your personal credit profile. These are **EIN-based business loans.**",
  },
  {
    q: "How fast can I get funded?",
    a: "Working capital, revenue financing, and MCA can fund the same day or in 24–48 hours. Equipment and line-of-credit typically take 3–7 days. SBA loans take 30–60 days on average.\n\n[See the illustrative walkthrough →](/deal-structures/hvac-contractor-185k-summer-crunch)",
  },
  {
    q: "What's the minimum monthly revenue?",
    a: "Most products require at least $8,000/month in gross business revenue and 6+ months in business. SBA loans typically require 2+ years of operating history.",
  },
  {
    q: "Do you charge upfront fees?",
    a: "No — never any upfront fees. Typically we're compensated by the lender at close. On occasion we may be compensated by the borrower after funding, but only under our **Accelerator Program** — which requires a signed agreement between you and Steady Path Funding and a minimum 720+ credit score. [Contact us here](/contact) for details.",
  },
];

export const CONTACT = {
  mainPhone: "888.275.0098",
  directPhone: "708.668.9012",
  fax: "708.668.9018",
  email: "Support@SteadyPathFunding.com",
  website: "www.steadypathfunding.com",
};
